import { BindAll } from 'lodash-decorators'
import { EnumApiTonghao } from '@xt/client/api/kindred-spirit'
import { $service } from '@xt/client/experimental/request/service'
import { action, observable, computed, toJS } from 'mobx'
import type { IGuildMyselfResp, IMemberResp, ManagerMemberUI, CityTypeInfo, GuildMyself } from './kindred-spirit'
import { PagePagination } from '@xt/client/utils/infinite-loading/index'
import { getAsDays } from '@xt/client/utils/kindred-spirit/index'
import { EnumJoinGroupStatus, EnumMemberStatus } from '@xt/client/enums/kindred-spirit/index'
import moment from 'moment'

@BindAll()
export class Manager {
  constructor() {}

  // 当前成员加入的分桐
  @observable joinedCity: GuildMyself | null = null
  @observable statistics: {
    memberCount: number
    waitExitCount: number
    waitJoinGroupCount: number
  } = {
    memberCount: 0,
    waitExitCount: 0,
    waitJoinGroupCount: 0
  }

  // 分桐列表
  pagePagination = new PagePagination<ManagerMemberUI>({
    url: EnumApiTonghao.MemberList,
    needCache: false,
    needLastId: false,
    pageSize: 20,
    mapValues: res => {
      return {
        dataSource: this.transformMembers(res.data),
        otherData: res.total
      }
    }
  })

  transformGuild(guild: IGuildMyselfResp): GuildMyself {
    return {
      id: guild.id,
      count: guild.memberCount,
      adcode: guild.adcode,
      cityName: guild.regionName,
      name: guild.guildName,
      description: guild.summary,
      cover: guild.pcCoverPhoto,
      memberIds: guild.previewMemberIds ?? [],
      status: guild.status,
      recruitStatus: guild.recruitStatus,
      appletAvatar: guild.appletAvatar,
      memberType: guild.memberType
    }
  }

  transformMembers(members: Array<IMemberResp>) {
    return members.map(m => {
      let subText: string = ''

      if (m.status === EnumMemberStatus.QuitAudit) {
        subText = '等待退出·已申请' + getAsDays(moment(m.requestExitTime).valueOf()) + '天'
      } else if (m.joinGroup === EnumJoinGroupStatus.NotInGroup) {
        subText = '等待入群·已加入' + getAsDays(moment(m.joinTime).valueOf()) + '天'
      } else {
        subText = '已加入' + getAsDays(moment(m.joinTime).valueOf()) + '天'
      }

      return {
        memberId: m.memberId.toString(),
        nickName: m.memberNickname,
        status: m.status,
        subText,
        specialty: m.specialty ? m.specialty.split('、') : [],
        memberType: m.memberType,
        joinGroup: m.joinGroup,
        joinTime: m.joinTime,
        phoneNum: m.phoneNum,
        summary: m.summary,
        focusRef: m.focusRef,
        visible: false
      }
    })
  }

  public async loadGuildMyself() {
    const [, res] = await $service<IGuildMyselfResp>({
      url: EnumApiTonghao.Myself
    })

    if (res && res.id) {
      this.setJoinedCity(this.transformGuild(res))
      this.setStatistics({
        waitExitCount: res.waitExitCount,
        waitJoinGroupCount: res.waitJoinGroupCount
      })
    }
  }

  public async initPage() {
    await this.loadGuildMyself()
  }

  // 退出操作
  public async handleAppleExit(data: { guildId: string }) {
    const [, res] = await $service<boolean>({
      url: EnumApiTonghao.MemberApplyExit,
      method: 'post',
      data
    })

    return res === true
  }

  // 待入群操作
  public async joinGroup(data: { guildId: string; memberId: string }) {
    const [, res] = await $service<boolean>({
      url: EnumApiTonghao.MemberJoinGroup,
      method: 'post',
      params: data
    })

    return res === true
  }

  // 退出审核操作
  public async exitAudit(data: { guildId: string; memberId: string }) {
    const [, res] = await $service<boolean>({
      url: EnumApiTonghao.MemberReview,
      method: 'post',
      params: data
    })

    return res === true
  }

  @action
  setJoinedCity(city: GuildMyself) {
    this.joinedCity = city
  }

  @action
  setStatistics(statistics: Partial<{ memberCount: number; waitExitCount: number; waitJoinGroupCount: number }>) {
    this.statistics = {
      ...this.statistics,
      ...statistics
    }
  }

  @action
  reset() {}
}
